import GroupMember from './src/main';

/* istanbul ignore next */
GroupMember.install = function(Vue) {

  Vue.component(GroupMember.name, GroupMember);
};

export default GroupMember;
